import BaseRepository from "../pages/repository";
import queryByKeys from "@/services/resources/mixins/query-by-keys";
import Kernel from "@oilstone/kernel";
import dayjs from "dayjs";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(queryByKeys);
    }

    listing() {
        const news = Kernel.resolve('resourceRegistry').find('news').repository.all().then(collection => {
            return collection.map(record => {
                return {
                    type: 'news',
                    resource: record
                }
            });
        });

        const blogPosts = Kernel.resolve('resourceRegistry').find('blog-posts').repository.all().then(collection => {
            return collection.map(record => {
                return {
                    type: 'blog-posts',
                    resource: record
                }
            });
        });

        const podcasts = Kernel.resolve('resourceRegistry').find('podcasts').repository.all().then(collection => {
            return collection.map(record => {
                return {
                    type: 'podcasts',
                    resource: record
                }
            });
        });

        // Promise.all([
        //     news,
        //     blogPosts,
        //     podcasts,
        // ]).then(collections => {
        //     console.log([].concat(...collections).map(record => {
        //         record.date = dayjs(record.publishAt || record.createdAt);
        //
        //         return record;
        //     }).sort((a, b) => {
        //         return a.resource.date.isBefore(b.resource.date) ? 1 : -1;
        //     }));
        // })

        return Promise.all([
            news,
            blogPosts,
            podcasts,
        ]).then(collections => {
            return [].concat(...collections).map(item => {
                item.resource.date = dayjs(item.resource.publishAt || item.resource.createdAt);

                return item;
            }).sort((a, b) => {
                return a.resource.date.isBefore(b.resource.date) ? 1 : -1;
            });
        })
    }
}

export default Repository;
